
<div>
    <div
        class  = "import-header "
        :id    = "id"
        :style = "'max-width: ' + (size.x-100) + 'px;'"
        ref="header"
    >
        <div
            class="v-flex primary white--text pt-1 pb-1"
            :style="'width:' + scrollWidth + 'px; ' + ((rightPadding === '0') ? 'border-top-left-radius: 6px;' : '')"
        >
            <div style="width: 30px" v-if="showUnits">

            </div>
            <div class="import-unit-col" v-if="showUnits">
                Anlagen
            </div>

            <div
                v-for  = "(column,colindex) in columns"
                class  = "import-column"
                :key   = "id + colindex"
                :style = "width(column)"
            >
                <a @click = "onSort(column, colindex)" class="white--text">
                    <span>{{ $t('importer.header.' + column.property) }}</span>
                    <span><v-icon color="white">{{ sortIcon (column.sort) }}</v-icon></span>
                </a>
            </div>
        </div>
    </div>

    <div
        class   = "import-content"
        :style  = "'max-width: ' + (size.x-100+rightPadding) + 'px; height: ' + (size.y-150) + 'px;'"
        @scroll = "onScroll"
    >
        <div
            :style="'width:' + scrollWidth + 'px'"
            class="pb-1"
        >
            <div v-for="(row, rowindex) in filteredRows" :key="'row-' + rowindex" >
                <div class="v-flex" style="border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: lightgrey">
                    <div v-if="showUnits" style="width: 30px; padding-left: 3px; padding-top: 0; margin-top: 8px; margin-bottom: 8px;" class="lm-border">
                        <v-icon size="22" color="primary">{{ row.id ? "mdi-file-refresh-outline" : "mdi-file-plus-outline" }}</v-icon>
                    </div>

                    <div class="import-unit-col pt-2 pl-0 pr-1 ml-1" v-if="showUnits">
                        <a @click="onUnits(row)">
                            <div
                                class  = "tool-button v-flex"
                                :class = "unitBorder (row)"
                            >
                                <div style="margin-top: -2px">
                                    <c-toolbar-button
                                        :size = "22"
                                        :color = "unitIconColor (row)"
                                        icon   = "mdi-elevator-passenger"
                                        :tooltip = "row.error ? $t('importer.error.' + row.error) : 'OK'"
                                    />
                                </div>
                                <v-spacer />
                                <div :class="unitIconColor (row) + '--text'">
                                    {{ row.units.length }}
                                </div>
                            </div>
                        </a>
                    </div>




                    <div
                        v-for  = "(column, columnIndex) in row.values"
                        class  = "import-column"
                        :key   = "'row-' + rowindex + '-Y' + columnIndex"
                        :style = "valueWidth(columnIndex)"
                    >
                        <div class="import-value" v-if = "column.value !== '-'">
                            {{ targetFormat ? toTargetFormat(column, columnIndex) : (column.value ? column.value : '---') }}
                        </div>

                        <div class="import-value error--text" v-if = "column.value === '-'">
                            Löschen
                        </div>

                        <div
                            v-if="!column.error && !column.warning && !columns[columnIndex].info"
                            class="import-value-ok success--text"
                        >
                            <span v-if="column.value">OK</span>
                        </div>
                        <div
                            v-if="column.error"
                            class="import-value-error error--text"
                        >
                            {{ $t("importer.error." + column.error) }}
                        </div>
                        <div
                            v-if="column.warning"
                            class="import-value-error warning--text"
                        >
                            {{ $t("importer.error." + column.warning) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
